'use client';

import { LandingPageProps } from '@/_types/common';
import HeroDisplayer from '../Sections/Hero/HeroDisplayer';
import SeniorsIsTheWay from '../Sections/SeniorsIsTheWay/SeniorsIsTheWay';
import WeAre from '../Sections/WeAre/WeAre';
import TalentAndJobMatching from '../Sections/TalentAndJobMatching/TalentAndJobMatching';
import PeopleCentered from '../Sections/PeopleCentered/PeopleCentered';
import ForAndBySeniors from '../Sections/ForAndBySeniors/ForAndBySeniors';
import ContactSection from '../ContactSection/contactsection';

const LandingPage = ({ hero }: LandingPageProps) => {
  return (
    <>
      <div className="flex flex-col">
        <HeroDisplayer hero={hero} />

        <SeniorsIsTheWay />

        <WeAre />

        <TalentAndJobMatching />

        <PeopleCentered />

        <ForAndBySeniors />

        <ContactSection />
      </div>
    </>
  );
};

export default LandingPage;
